import {Typography} from '@yandex-delivery/ui'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import React from 'react'

import {type BlockWithRequirementsType} from '../../../../../../api'
import {Paper} from '../../../../../../components/ui'
import {Subtitle, Title} from '../ui'
import styleClasses from './classes.module.css'
import {Requirement} from './components'

type Props = {
  isSubblock?: boolean
  block: BlockWithRequirementsType
}

export function BlockWithRequirements({block, isSubblock}: Props) {
  const {title, subtitle, titleValue, requirements} = block
  const content = (
    <div className={styleClasses.block}>
      <div className={styleClasses.headerWrapper}>
        <div className={styleClasses.header}>
          <Title small={isSubblock} title={title} />
          {subtitle && <Subtitle subtitle={subtitle} small />}
        </div>
        {titleValue && (
          <Typography density="tight" level="title3" weight="regular">
            <SafeHTML html={titleValue} />
          </Typography>
        )}
      </div>
      {!!requirements.length && (
        <div className={styleClasses.requirements}>
          {requirements.map(requirement => (
            <Requirement key={requirement.id} requirement={requirement} />
          ))}
        </div>
      )}
    </div>
  )

  return isSubblock ? content : <Paper>{content}</Paper>
}
